import { default as Services } from "./services-root";

export default Services;
